import PromiseHelper from "base/PromiseHelper";
import GalleryHelper from "GalleryHelper";
import GalleryModal from "modals/GalleryModal";
import PageAnimations from "webPage/PageAnimations";
import {svg_include} from "index";

export default class StyleGallery {
    constructor($element) {
        this.$element = $element;
        this.page = this.$element.attr('data-page');
        this.galleryName = this.$element.attr('data-gallery');
        this.perPage = 'undefined' !== typeof this.$element.attr('data-per-page') ? parseInt(this.$element.attr('data-per-page')) : 12;

        this.$gallery_items = this.$element.find('.js-gallery-items');
        this.bindEvents();
    }

    bindEvents() {
        let me = this;

        this.$element.on("click", ".js-view-image", function () {
            let $item = $(this);

            let modal = new GalleryModal(me.page, me.galleryName, parseInt($item.attr("data-id")), $item.attr("data-video-url"));
            modal.show();
            return false;
        });
    }

    async loadMoreImages(offset) {
        this.$element.addClass('a').removeClass('a--play');

        let gallery = await PromiseHelper.delayed_promise(GalleryHelper.get_gallery(this.page, this.galleryName), 300);

        let images = gallery.images;
        let newImages = images.slice(offset, offset + this.perPage);

        let $images = eotwJSXFactory('div', {className: "box-gallery__grid"});

        newImages.forEach((image, index) => {
            $images.append(
                eotwJSXFactory('div', {className: "box-gallery__item box-gallery__item--" + (index + 1) + " a__i a__i--hapi a__i--dur-" + (600 + (75 * index)) + " a__i--delay-" + (50 * index)}, [
                    eotwJSXFactory('button', {type: "button", className: "zoom-image js-view-image", 'data-id': image.id}, [
                        eotwJSXFactory('span', {className: "zoom-image__icon", unsafeHtml: svg_include("zoom-icon")}),
                        eotwJSXFactory('span', {className: "zoom-image__box"}),
                        eotwJSXFactory('span', {className: "bg-image"}, [
                            this.generatePictureElement(image, index + 1)
                        ])
                    ])
                ])
            )
        });

        this.$gallery_items.append($images);

        PageAnimations.check();
    }

    generatePictureElement(image, index) {
        let prefix = this.getGalleryPrefix();
        return (
            eotwJSXFactory('picture', null, [
                eotwJSXFactory('source', {media: "(max-width: 599px)", srcSet: this.getImageSize(image, prefix + index + '_mobile')}),
                eotwJSXFactory('source', {media: "(max-width: 759px)", srcSet: this.getImageSize(image, prefix + index + '_phablet')}),
                eotwJSXFactory('source', {media: "(max-width: 959px)", srcSet: this.getImageSize(image, prefix + index + '_tablet')}),
                eotwJSXFactory('source', {media: "(max-width: 1599px)", srcSet: this.getImageSize(image, prefix + index + '_small')}),
                eotwJSXFactory('img', {src: image.url,
                     className: "bg-image",
                     alt: image.alt,
                     'data-object-fit': "cover"}
                )
            ])
        )
    }

    getGalleryPrefix() {
        switch (this.galleryName) {
            case 'style_images_gallery':
                return 'style-gallery-'
        }
    }

    getImageSize(image, size) {
        return 'undefined' !== typeof image.sizes[size] ? image.sizes[size] : image.url;
    }
}
